/**
 * BB Selector Tipo de Lente — 4 opciones
 * Demo | Neutros | Receta | Lectura  (un solo producto, sin redirigir)
 *
 *  - demo:    ATC normal.                         properties[Tipo de lente] = Demo
 *  - neutros: ATC normal + texto.                 properties[Tipo de lente] = Neutros
 *  - receta:  oculta el ATC y muestra MI botón "Continuar con tu receta",
 *             que dispara el flujo de LensAdvisor programáticamente.
 *  - lectura: ATC bloqueado hasta elegir aumento. properties[Tipo de lente] = Lectura
 *                                                 properties[Aumento]       = "+X.XX"
 *
 * LensAdvisor (confirmado con el equipo de LA): su botón <lensadvizor-btn> arranca
 * en display:none y LA lo muestra UNA sola vez en su init; si estaba oculto, no lo
 * vuelve a mostrar. Por eso NO peleamos con su visibilidad: lo dejamos siempre
 * oculto y abrimos el flujo nosotros vía .click() (la vía soportada), seteando
 * data-la-variant-id con la variante actual y esperando LensAdvizor:init:complete.
 */
(function () {
  'use strict';

  var container, form, atcBlock, atcBtn, recetaCta;
  var propTypeInput, propAumInput;
  var LABELS = {};

  function init() {
    container = document.getElementById('BbSelectorLente');
    if (!container) return;

    LABELS = {
      demo: container.dataset.labelDemo || 'Demo',
      neutros: container.dataset.labelNeutros || 'Neutros',
      receta: container.dataset.labelReceta || 'Receta',
      lectura: container.dataset.labelLectura || 'Lectura'
    };

    // 1. Recordar el wrapper original ANTES de mover
    var origSection = container.closest('.shopify-section');

    // 2. Mover al área de info del producto (antes de los buy buttons)
    moveToProductInfo();

    // 3. Colapsar el wrapper original ya vacío
    if (origSection && !origSection.contains(container)) {
      origSection.style.display = 'none';
    }

    // 4. Form del producto + inputs ocultos
    form = document.querySelector('.product-single__form, form[action*="/cart/add"]');
    if (form) createHiddenInputs();

    // 5. Cachear el bloque del ATC y crear mi botón de Receta
    cacheAtc();
    createRecetaCta();

    // 6. Mostrar el contenedor (estaba oculto para evitar FOUC)
    container.style.display = '';

    // 7. Modo inicial
    switchMode(container.dataset.defaultMode || 'demo');

    // 8. Delegación de eventos (tabs + pills)
    container.addEventListener('click', function (e) {
      var tab = e.target.closest('.bb-sl__tab');
      if (tab) { switchMode(tab.dataset.mode); return; }
      var pill = e.target.closest('.bb-sl__pill');
      if (pill && !pill.classList.contains('is-disabled')) { selectAumento(pill); return; }
    });

    // 9. Bloquear el submit si Lectura no tiene aumento elegido
    if (form) {
      form.addEventListener('submit', function (e) {
        if (currentMode() === 'lectura' && !selectedAumento()) {
          e.preventDefault();
          flashHint();
        }
      });
    }

    // 10. Al cambiar variante: re-cachear ATC, re-aplicar gating y re-ocultar LA
    document.addEventListener('variant:change', function () {
      setTimeout(function () {
        cacheAtc();
        applyAtcState(currentMode());
        hideAllLensAdvisor();
      }, 50);
    });

    // 11. LensAdvisor inyecta/actualiza su botón en runtime: mantenerlo oculto
    watchLensAdvisor();
  }

  // ─── Estado ────────────────────────────────────────────────────────────
  function currentMode() {
    var t = container.querySelector('.bb-sl__tab.is-active');
    return t ? t.dataset.mode : 'demo';
  }
  function selectedAumento() {
    var p = container.querySelector('.bb-sl__pill.is-selected');
    return p ? p.dataset.aumento : '';
  }
  function getSelectedVariantId() {
    if (!form) return '';
    var idInput = form.querySelector('[name="id"]');
    return idInput ? idInput.value : '';
  }

  // ─── Posicionamiento DOM ───────────────────────────────────────────────
  function moveToProductInfo() {
    var formEl = document.querySelector('.product-single__form');
    if (!formEl) return;
    var inner = formEl.closest('.product-block');
    if (!inner) return;
    var outer = inner.parentElement ? inner.parentElement.closest('.product-block') : null;
    var target = outer || inner;
    if (target && target.parentNode) target.parentNode.insertBefore(container, target);
  }

  function cacheAtc() {
    atcBtn = document.querySelector('[data-add-to-cart]');
    if (!atcBtn) { atcBlock = null; return; }
    var inner = atcBtn.closest('.product-block');
    if (!inner) { atcBlock = null; return; }
    var outer = inner.parentElement ? inner.parentElement.closest('.product-block') : null;
    atcBlock = outer || inner;
  }

  // ─── Mi botón de Receta (dispara LensAdvisor) ──────────────────────────
  function createRecetaCta() {
    if (!atcBlock || recetaCta) return;
    recetaCta = document.createElement('button');
    recetaCta.type = 'button';
    recetaCta.className = 'btn btn--full bb-sl__receta-cta';
    recetaCta.textContent = container.dataset.recetaCta || 'Continuar con tu receta';
    recetaCta.style.display = 'none';
    recetaCta.addEventListener('click', function () {
      openLensAdvizor(getSelectedVariantId());
    });
    atcBlock.parentNode.insertBefore(recetaCta, atcBlock.nextSibling);
  }

  // ─── Inputs ocultos ────────────────────────────────────────────────────
  function createHiddenInputs() {
    propTypeInput = document.createElement('input');
    propTypeInput.type = 'hidden';
    propTypeInput.name = 'properties[Tipo de lente]';
    propTypeInput.value = LABELS.demo;
    form.appendChild(propTypeInput);

    propAumInput = document.createElement('input');
    propAumInput.type = 'hidden';
    propAumInput.name = 'properties[Aumento]';
    propAumInput.value = '';
    propAumInput.disabled = true; // disabled => no se envía al carro
    form.appendChild(propAumInput);
  }

  // ─── Cambio de modo ────────────────────────────────────────────────────
  function switchMode(mode) {
    container.querySelectorAll('.bb-sl__tab').forEach(function (t) {
      var active = t.dataset.mode === mode;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
      if (active) {
        var label = document.getElementById('BbSlActiveLabel');
        if (label) label.textContent = t.dataset.label;
      }
    });

    container.querySelectorAll('.bb-sl__panel').forEach(function (p) {
      if (p.dataset.panel === mode) p.removeAttribute('hidden');
      else p.setAttribute('hidden', '');
    });

    updateProperties(mode);
    updateAtcVisibility(mode);
    applyAtcState(mode);
  }

  function updateProperties(mode) {
    if (!propTypeInput) return;
    if (mode === 'lectura') {
      propTypeInput.value = LABELS.lectura;
      if (propAumInput) {
        propAumInput.disabled = false;
        propAumInput.value = selectedAumento();
      }
    } else {
      propTypeInput.value = LABELS[mode] || LABELS.demo;
      if (propAumInput) { propAumInput.disabled = true; propAumInput.value = ''; }
    }
  }

  // ─── Selección de aumento ──────────────────────────────────────────────
  function selectAumento(pill) {
    container.querySelectorAll('.bb-sl__pill').forEach(function (p) { p.classList.remove('is-selected'); });
    pill.classList.add('is-selected');
    if (propAumInput && !propAumInput.disabled) propAumInput.value = pill.dataset.aumento;
    hideHint();
    applyAtcState('lectura');
  }

  // ─── ATC nativo vs botón de Receta ─────────────────────────────────────
  function updateAtcVisibility(mode) {
    if (mode === 'receta') {
      if (atcBlock) atcBlock.style.display = 'none';
      if (recetaCta) recetaCta.style.display = '';
    } else {
      if (atcBlock) atcBlock.style.display = '';
      if (recetaCta) recetaCta.style.display = 'none';
    }
    // El botón propio de LensAdvisor queda SIEMPRE oculto: el flujo lo abrimos nosotros.
    hideAllLensAdvisor();
  }

  /**
   * Bloqueo visual del ATC en Lectura hasta elegir aumento.
   * NO tocamos el atributo `disabled` real (Impulse maneja el sold-out);
   * el submit se bloquea en el handler. Acá solo damos la pista visual.
   */
  function applyAtcState(mode) {
    if (!atcBtn) return;
    var gated = (mode === 'lectura' && !selectedAumento());
    atcBtn.classList.toggle('bb-sl-atc-gated', gated);
  }

  function flashHint() {
    var hint = container.querySelector('[data-lectura-hint]');
    if (hint) hint.removeAttribute('hidden');
    container.querySelectorAll('.bb-sl__pill:not(.is-disabled)').forEach(function (p) {
      p.classList.add('bb-sl__pill--nudge');
    });
    setTimeout(function () {
      container.querySelectorAll('.bb-sl__pill--nudge').forEach(function (p) {
        p.classList.remove('bb-sl__pill--nudge');
      });
    }, 600);
  }
  function hideHint() {
    var hint = container.querySelector('[data-lectura-hint]');
    if (hint) hint.setAttribute('hidden', '');
  }

  // ─── LensAdvisor: ocultar su botón + abrir el flujo nosotros ───────────

  /** Oculta TODOS los botones propios de LensAdvisor. Nunca toca su modal. */
  function hideAllLensAdvisor() {
    var laElements = document.querySelectorAll('lensadvizor-btn, #la-select-lenses-btn, .la-select-lenses-btn');
    laElements.forEach(function (el) {
      var section = el.closest('.shopify-section');
      // Sección dedicada de LA (sin form/ATC/selector) → ocultar entera.
      var dedicated = section && !section.querySelector('.product-single__form, [data-add-to-cart], #BbSelectorLente');
      if (dedicated) { section.style.display = 'none'; return; }
      // Botón inyectado dentro de la sección del producto → ocultar solo el botón.
      el.style.display = 'none';
    });
  }

  /** Espera a que LensAdvisor esté inicializado antes de disparar el flujo. */
  function laReady(cb) {
    var done = false;
    function run() { if (done) return; done = true; cb(); }
    if (window.LensAdvizor && window.LensAdvizor.loadingCompleted) { run(); return; }
    document.addEventListener('LensAdvizor:init:complete', run, { once: true });
  }

  /** Abre el flujo de receta para la variante actualmente seleccionada. */
  function openLensAdvizor(variantId) {
    laReady(function () {
      var btns = document.querySelectorAll('lensadvizor-btn, #la-select-lenses-btn');
      if (!btns.length) return;
      // Sincronizar la variante elegida en nuestra UI con el/los botón(es) de LA
      if (variantId) {
        btns.forEach(function (b) { b.setAttribute('data-la-variant-id', variantId); });
      }
      // .click() es la vía soportada: corre launchLensAdvizorModal() que arma el
      // estado y abre el modal. Funciona aunque el botón esté oculto.
      var target = document.querySelector('lensadvizor-btn') || btns[0];
      if (target) target.click();
    });
  }

  /** LA re-muestra su botón en init/cambio de variante; lo re-ocultamos. */
  function watchLensAdvisor() {
    hideAllLensAdvisor();
    var t;
    var obs = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(hideAllLensAdvisor, 80);
    });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 15000);
  }

  // ─── Init ──────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();